import React, { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { useDecimalFormatter } from 'hooks/useNumberFormatters'

function useLuxLoyaltyWelcomeCopy(tier: App.LuxLoyaltyTier): Array<React.ReactNode> {
  const programConfigDetails = useAppSelector(state => state.luxLoyalty.programConfig?.configDetails)
  const decimalFormat = useDecimalFormatter()

  const tierConfig = programConfigDetails?.tiers[tier]
  const welcomePoints = decimalFormat(tierConfig?.welcomePoints ?? 0)

  return useMemo(() => {
    if (!programConfigDetails) return []

    return [
      `Earn & redeem ${programConfigDetails.currencyName} on every booking`,
      `Unlock ${tier === 'silver' ? 'Gold or ' : ''}Platinum status as you spend`,
      <>Enjoy a <b>{welcomePoints} point</b> welcome gift</>,
    ]
  }, [programConfigDetails, tier, welcomePoints])
}

export default useLuxLoyaltyWelcomeCopy
